export const IDS_URL_PARAM_NAME = 'ids';
export const DAMAGE_REPORT_REFERENCE_NUMBER_PARAM_NAME = "damageReportReferenceNumber";

export const getParam = (paramName) => {
    const queryString = window.location.search;
    let urlParams = new URLSearchParams(queryString);
    return urlParams.get(paramName);
}